<!-- 
 @fileoverview This is the SMS Self-Service router 
 @author Harish Kumaran
 @created June, 2024
 -->
<router-outlet></router-outlet>